import { render } from "./system_roles.vue?vue&type=template&id=b789be04&scoped=true"
import script from "./system_roles.vue?vue&type=script&lang=js"
export * from "./system_roles.vue?vue&type=script&lang=js"

import "./system_roles.vue?vue&type=style&index=0&id=b789be04&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b789be04"]])

export default __exports__